import script from "./SidePanel.vue?vue&type=script&setup=true&lang=js"
export * from "./SidePanel.vue?vue&type=script&setup=true&lang=js"

import "./SidePanel.vue?vue&type=style&index=0&id=57cc605c&lang=css"

const __exports__ = script;

export default __exports__